<div class="banner_header">
  <div class="col-md-12">
    <h2> Grievance Readdressal System</h2>
  </div>
</div>

<div class="container download_section pad_btm_size">


  <div class="row">
    <div class="col-md-8 instruc_left">
      <div style="padding: 0px 15px;">
        <h2>Instructions</h2>
        <p> 1. This CBT Grievance readdressal system is for raising your grievance related to CBT Exam and Fee payments.
        </p>
        <p> 2. For Grievance related to CBT Exam, a grievance can be raised only by the Invigilator using his CBT
          Attendance App login. </p>
        <p> 3. An Invigilator can raise a grievance for the candidates mapped to his centre alone. </p>
        <p> 4. Kindly check the displayed data of the candidate before raising the grievance </p>
        <p> 5. A grievance for a candidate can be raised only once. </p>
        <p> 6. A grievance Ticket ID will be generated for each grievance raised and the status can be tracked in the
          invigilator login. </p>
        <p> 7. All tickets raised details will be available in the Invigilator login. </p>
      </div>
    </div>

    <div class="col-md-4 instruc_right">
      <div *ngIf="bool_instruction" style="padding: 0px 15px;">
        <button type="button" class="instrc_btn form-control" routerLink="/dashboard/ericount">Admin Login</button>
        <!-- <button type="button" class="instrc_btn form-control" routerLink="/trackId">Track your complaint</button>
        <button class="instrc_btn form-control" style="background-color: #218838;" value="pdu" routerLink="/verifyreport"> Payment Verified List
        </button>
        <a class="instrc_btn form-control" target="_blank" value="pdu" href="https://nimionlineadmission.in/aitt/resultlogin.php"> CBT Response Sheet
        </a> -->

                <!-- <button class="instrc_btn form-control" value="pdu" routerLink="/priForm"> Payment Related Issue
        </button> -->

        <!--<button class="instrc_btn form-control" value="dpr" (click)="complaint_fn($event)">Duplicate payments / Refund Issue</button> -->
        <!-- <button class="instrc_btn form-control" value="eri" routerLink="/invigilator_dashboard/invigiericount"> Exam
          related Issue </button> -->
        <!-- <button type="button" class="instrc_btn form-control" routerLink="/candidatedashboard">Candidate Login</button> -->
        <!-- <a style="text-decoration: none; text-align: center;" class="instrc_btn form-control"
          href="https://mirror5.nimionlinetesting.in/aitt_grievances" target="_blank">
          Upload CBT CCTV Videos </a> -->


      </div>

      <!--Raise complaint Login Start-->
      <div *ngIf="examFormloginBoolean">
        <h2>Login with your invigilator credentials</h2>
        <div class="card-body" style="padding: 0px;">
          <form [formGroup]="loginForm" (ngSubmit)="onSubmitLogin()">
            <div class="form-row">
              <div class="form-group col-12">
                <label>Email</label>
                <input type="text" formControlName="email" class="form-control"
                  [ngClass]="{ 'is-invalid': submitted && l.email.errors }" maxlength="50"
                  (keypress)="omit_email($event)" />
                <div *ngIf="submitted && l.email.errors" class="invalid-feedback">
                  <div *ngIf="l.email.errors.required">Email is required</div>
                  <div *ngIf="l.email.errors.email">
                    Email must be a valid email address
                  </div>
                  <div *ngIf="l.email.errors.pattern">
                    Enter valid Email address
                  </div>

                </div>
              </div>

              <div class="form-group col-12">
                <label>Mobile Number </label>
                <input type="text" formControlName="mobileno" class="form-control"
                  [ngClass]="{ 'is-invalid': submitted && l.mobileno.errors }" (keypress)="omit_number($event)"
                  maxlength="10" />
                <div *ngIf="submitted && l.mobileno.errors" class="invalid-feedback">
                  <div *ngIf="l.mobileno.errors.required">
                    Mobile no required
                  </div>
                </div>
                <div *ngIf="submitted && l.mobileno.errors" class="invalid-feedback">
                  <div *ngIf="l.mobileno.errors.pattern">
                    Mobile no must 10 digit
                  </div>
                </div>
                <!-- <div *ngIf="submitted && f.mobileno.errors" class="invalid-feedback">
                          <div *ngIf="f.mobileno.errors.max"> Mobile no must 10 digit</div>
                      </div> -->
              </div>

              <div class="form-group col-12">
                <div class="text-center">
                  <button class="btn btn-primary mr-1">Login</button>
                  <!-- <button type="button" (click)="onLoginReset()" class="btn btn-primary mr-1">Login</button> -->
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <!--Raise complaint Login End-->

      <!--Raise complaint Login Start-->
      <div *ngIf="bool_trackCompEnter">
        <div class="card-body" style="padding: 0px;">



          <form [formGroup]="trackIdForm" (ngSubmit)="onSubmitTrackId()">
            <div class="form-row">
              <div class="form-group col-12">
                <label>Enter Your Ticket ID</label>
                <input type="text" formControlName="ticketId" class="form-control"
                  [ngClass]="{ 'is-invalid': submitted && t.ticketId.errors }" maxlength="12" />
                <div *ngIf="submitted && t.ticketId.errors" class="invalid-feedback">
                  <div *ngIf="t.ticketId.errors.required">TicketID is required</div>
                </div>
              </div>

              <div class="form-group col-12">
                <div class="text-center">
                  <button class="btn btn-primary mr-1">Login</button>
                  <!-- <button type="button" (click)="onLoginReset()" class="btn btn-primary mr-1">Login</button> -->
                </div>
              </div>


            </div>
          </form>
        </div>
      </div>
      <!--Raise complaint Login End-->

      <!--Admin From Start-->
      <div *ngIf="bool_AdminLogin">
        <div class="card-body" style="padding: 0px;">
          <h2>Admin</h2>
          <form [formGroup]="adminForm" (ngSubmit)="onSubmitAdmin()">
            <div class="form-row">
              <div class="form-group col-12">
                <label>User Name</label>
                <input type="text" formControlName="username" class="form-control"
                  [ngClass]="{ 'is-invalid': submitted && admin.username.errors }" maxlength="20" />
                <div *ngIf="submitted && admin.username.errors" class="invalid-feedback">
                  <div *ngIf="admin.username.errors.required">username is required</div>
                </div>
              </div>
              <div class="form-group col-12">
                <label>Password</label>
                <input type="text" formControlName="password" class="form-control"
                  [ngClass]="{ 'is-invalid': submitted && admin.password.errors }" maxlength="12" />
                <div *ngIf="submitted && admin.password.errors" class="invalid-feedback">
                  <div *ngIf="admin.password.errors.required">password is required</div>
                </div>

              </div>
              <div class="form-group col-12">
                <div class="text-center">
                  <button class="btn btn-primary mr-1">Login</button>
                  <!-- <button type="button" (click)="onLoginReset()" class="btn btn-primary mr-1">Login</button> -->
                </div>
              </div>


            </div>
          </form>
        </div>
      </div>
      <!--Admin Form End-->
    </div>


  </div>


  <div class="row" *ngIf="bool_issue_type">
    <div class="col-md-12">
      <!-- <div>
        <select
          class="form-control"
          [(ngModel)]="selectedGroup"
          (change)="getVal()"
        >
          <option value="undefined" disabled="true">
            Select Type Of Issue
          </option>

          <option *ngFor="let group of groups" [ngValue]="group">
            {{ group.name }}
          </option>
        </select>
      </div> -->

      <div *ngIf="form1">
        <!-- main app container -->
        <div class="card m-3">
          <h3 class="card-header">Payment Related Issue</h3>
          <div class="card-body">
            <form [formGroup]="bdnuForm" (ngSubmit)="onSubmit()">
              <div class="form-row">
                <div class="form-group col-3">
                  <label>State</label>

                  <select formControlName="state" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.state.errors }" (change)="onChangeState($event)">
                    <option [selected]="true" value="" [disabled]="true">Select State</option>
                    <option *ngFor="let country of state" [value]="country.State">
                      {{ country.State }}
                    </option>
                  </select>
                  <div *ngIf="submitted && f.state.errors" class="invalid-feedback">
                    <div *ngIf="f.state.errors.required">Select Your State</div>
                  </div>
                </div>

                <div class="form-group col-3">
                  <label>District</label>

                  <select formControlName="district" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.district.errors }" (change)="onChangeDistrict($event)">
                    <option [selected]="true" value="" [disabled]="true">Select District</option>
                    <option *ngFor="let country of district" [value]="country.district">
                      {{ country.district}}
                    </option>
                  </select>
                  <div *ngIf="submitted && f.district.errors" class="invalid-feedback">
                    <div *ngIf="f.district.errors.required">Select Your District</div>
                  </div>
                </div>

                <div class="form-group col-3">
                  <label>ITI Code</label>
                  <select formControlName="iticode" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.iticode.errors }" (change)="onChangeIticode($event)">
                    <option [selected]="true" value="" [disabled]="true">Select ITI Code</option>
                    <option *ngFor="let city of iticode" [value]="city.iticode">
                      {{ city.iticode }}
                    </option>
                  </select>
                  <div *ngIf="submitted && f.iticode.errors" class="invalid-feedback">
                    <div *ngIf="f.iticode.errors.required">
                      Select Your ITI code
                    </div>
                  </div>
                </div>

                <div class="form-group col-3">
                  <label>Trade</label>
                  <select formControlName="trade" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.trade.errors }">
                    <option [selected]="true" value="" [disabled]="true">Select Trade</option>
                    <option *ngFor="let trad of trade" [value]="trad.trade">
                      {{ trad.trade }}
                    </option>
                  </select>
                  <div *ngIf="submitted && f.trade.errors" class="invalid-feedback">
                    <div *ngIf="f.trade.errors.required">
                      Select Your Trade
                    </div>
                  </div>
                </div>

                <div class="form-group col-4">
                  <label>Name</label>
                  <input type="text" formControlName="name" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.name.errors }" maxlength="50"
                    placeholder="Enter Your Name" (keypress)="omit_text($event)" />
                  <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                    <div *ngIf="f.name.errors.required">Enter Your Name</div>
                  </div>
                </div>

                <div class="form-group col-4">
                  <label>Email Id</label>
                  <input type="text" formControlName="email" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.email.errors }" maxlength="50"
                    placeholder="Enter Your Email Address" (keypress)="omit_email($event)" />
                  <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                    <div *ngIf="f.email.errors.required">Enter Your Email Id</div>
                    <div *ngIf="f.email.errors.pattern">
                      Enter Your Email Id must be a Valid Address
                    </div>

                  </div>
                </div>

                <div class="form-group col-4">
                  <label>Mobile Number</label>
                  <input type="text" formControlName="mobileno" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.mobileno.errors }" maxlength="10"
                    placeholder="Enter Your Mobile Number" (keypress)="omit_number($event)" />
                  <div *ngIf="submitted && f.mobileno.errors" class="invalid-feedback">
                    <div *ngIf="f.mobileno.errors.required">
                      Enter Your Mobile Number
                    </div>
                  </div>

                  <!-- <div *ngIf="submitted && f.mobileno.errors" class="invalid-feedback">
                            <div *ngIf="f.mobileno.errors.max"> Mobile no must 10 digit</div>
                        </div> -->
                </div>

                <div class="form-group col-4">
                  <label>CC Refernce Number</label>
                  <input type="text" formControlName="ccrefno" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.ccrefno.errors }" maxlength="12"
                    placeholder="Enter CC Ref Number" (keypress)="omit_number($event)" />
                  <div *ngIf="submitted && f.ccrefno.errors" class="invalid-feedback">
                    <div *ngIf="f.ccrefno.errors.required">
                      Enter Your CC Refernce number
                    </div>
                  </div>
                  <div *ngIf="submitted && f.ccrefno.errors" class="invalid-feedback">
                    <div *ngIf="f.ccrefno.errors.pattern">
                      Enter Your CC Refernce number Only Number
                    </div>
                  </div>
                </div>

                <div class="form-group col-4">
                  <label>Order Id</label>
                  <input type="text" formControlName="orderid" class="form-control" maxlength="20"
                    placeholder="Enter Order ID" (keypress)="omit_spl($event)" />

                </div>

                <div class="form-group col-4">
                  <label>Payment Date</label>
                  <!-- <input type="date" formControlName="date" pattern="\d{4}-\d{2}-\d{2}"  class="form-control" [ngClass]="{ 'is-invalid': submitted && f.date.errors }" /> -->
                  <!-- <mat-form-field>
                          <input matInput placeholder="Choose a date">
                          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field> -->

                  <!-- <dp-date-picker theme="dp-material" class=" date_cus" [config]="datePickerConfig" required="true" formControlName="date" [ngClass]="{ 'is-invalid': submitted && f.date.errors }" [disabled]="true"> </dp-date-picker> -->

                  <!-- <input name="someName" [disabled]="false" theme="dp-material" class="form-control" formControlName="date"  [dpDayPicker]="datePickerConfig" [ngClass]="{ 'is-invalid': submitted && f.date.errors }"/> -->

                  <input theme="dp-material" class="form-control" formControlName="date"
                    [dpDayPicker]="datePickerConfig" [ngClass]="{ 'is-invalid': submitted && f.date.errors }"
                    placeholder="Enter Payment Date" maxlength="10" />

                  <div *ngIf="submitted && f.date.errors" class="invalid-feedback">
                    <div *ngIf="f.date.errors.required">
                      Choose Your Payment Date
                    </div>
                  </div>
                </div>

                <div class="col-md-2">
                  <label style="display: block; text-align: left;">Type of Payment Done </label>
                  <div style="text-align: left;">
                    <input type="radio" value="radio1" formControlName="radiobtn" [(ngModel)]="readioSelected"
                      (change)="showContent(readioSelected)" />
                    <span> Bulk </span>
                    <input type="radio" value="radio2" formControlName="radiobtn" [(ngModel)]="readioSelected"
                      (change)="showContent(readioSelected)" />
                    <span> Single </span>
                  </div>
                  <div *ngIf="submitted && f.radiobtn.errors" class="invalid-feedback">
                    <div *ngIf="f.radiobtn.errors.required">
                      Choose Your Payment Type
                    </div>
                  </div>
                </div>

                <div *ngIf="bulk_bool" class="form-group col-10">

                  <div class="row">
                    <div class="form-group col-6">
                      <label>Number of Students </label>
                      <input type="text" formControlName="numberofstud" class="form-control" [ngModel]="numberStud"
                        [ngClass]="{
                        'is-invalid': submitted && f.numberofstud.errors
                      }" maxlength="2" (keyup)="onKey($event)" maxlength="2" placeholder="Enter Number of Students"
                        (keypress)="omit_number($event)" />
                      <div *ngIf="submitted && f.numberofstud.errors" class="invalid-feedback">
                        <div *ngIf="f.numberofstud.errors.required">
                          Enter Number of Students
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-6">
                      <label>Total Amount</label>
                      <input [attr.disabled]='true' type="text" formControlName="amount" [(ngModel)]="totAmount"
                        class="form-control" [ngClass]="{
                        'is-invalid': submitted && f.amount.errors
                      }" placeholder="Total Amount" />
                      <div *ngIf="submitted && f.amount.errors" class="invalid-feedback">
                        <div *ngIf="f.amount.required">
                          Enter Your Amount
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="single_bool" class="form-group col-10">
                  <div class="form-group col-6">
                    <label>Register Number</label>

                    <input type="text" formControlName="singlerollno" class="form-control"
                      [ngClass]="{ 'is-invalid': submitted && f.singlerollno.errors }" minlength="12" maxlength="12"
                      placeholder="Enter Your Register Number" (keypress)="omit_number($event)" />
                    <div *ngIf="submitted && f.singlerollno.errors" class="invalid-feedback">
                      <div *ngIf="f.singlerollno.errors.required">
                        Enter Your Register Number
                      </div>
                    </div>

                    <!-- <input type="text" formControlName="singlerollno" class="form-control" [ngModel]="numberStud"
                      [ngClass]="{
                        'is-invalid': submitted && f.singlerollno.errors
                      }" maxlength="2" maxlength="12" placeholder="Enter Number of Students"
                      (keypress)="omit_spl($event)" /> -->

                    <!-- <select formControlName="singlerollno" class="form-control" [ngClass]="{
                        'is-invalid': submitted && f.singlerollno.errors
                      }">
                      <option *ngFor="let rollno of singlerollnoval" [value]="rollno">
                        {{ rollno }}
                      </option>
                    </select> -->

                  </div>
                </div>



                <div class="form-group col-12">
                  <label>Additional Description</label>
                  <textarea formControlName="descreption" class="form-control" [ngClass]="{
                    'is-invalid': submitted && f.descreption.errors
                  }" rows="3" (keypress)="omit_spl($event)" maxlength="500" style="resize: none;">

                  </textarea>
                  <!-- <input
                    type="text"
                    formControlName="descreption" class="form-control"
                  [ngClass]="{
                    'is-invalid': submitted && f.descreption.errors
                  }"

                  /> -->

                  <div *ngIf="submitted && f.descreption.errors" class="invalid-feedback">
                    <div *ngIf="f.descreption.errors.maxLength">
                      Enter Your Description
                    </div>
                  </div>
                </div>
                <div class="form-group form-check">
                  <input type="checkbox" formControlName="acceptTerms" id="acceptTerms" class="form-check-input"
                    [ngClass]="{
                      'is-invalid': submitted && f.acceptTerms.errors
                    }" />
                  <label for="acceptTerms" class="form-check-label">I agree that all the above information are
                    correct</label>
                  <div *ngIf="submitted && f.acceptTerms.errors" class="invalid-feedback">
                    I agree that all the above information are correct
                  </div>
                </div>

                <div class="form-group col-12">
                  <div class="text-center">
                    <button class="btn btn-primary mr-1">Submit</button>
                    <button class="btn btn-secondary" type="reset" (click)="onReset()">
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!--FORM2 Start-->
      <div *ngIf="form2">
        <div class="card m-3">
          <h5 class="card-header">Duplicate payments / Refund Issues</h5>
          <div class="card-body">

          </div>
        </div>
      </div>
      <!--FORM2 End-->
      <!--FORM3 Start-->
      <div *ngIf="form3">
        <!--Form3 Login Start-->


        <!--Form3 Login End-->
        <!--Form3 IF Start-->

        <div class="card m-3">
          <h5 class="card-header" style="font-size: 21px">
            Exam Related Issue
          </h5>
          <div class="card-body">
            <form [formGroup]="eriForm" (ngSubmit)="onERISubmit()">
              <div class="form-row">
                <!-- <div class="form-group col-3">
                  <label>Id</label>

                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="genrateid"
                    formControlName="genrateid"
                  />


                </div> -->
                <div class="form-group col-3">
                  <label>Email </label>

                  <input type="text" formControlName="email" class="form-control" [(ngModel)]="mail_single"
                    [attr.disabled]="true" />

                  <div *ngIf="submitted && eri.email.errors" class="invalid-feedback">
                    <div *ngIf="eri.email.errors.required">
                      Email is required
                    </div>
                  </div>
                </div>

                <div class="form-group col-3">
                  <label>State</label>

                  <input type="text" formControlName="state" class="form-control" [(ngModel)]="state_single"
                    [attr.disabled]="true" />

                  <div *ngIf="submitted && eri.state.errors" class="invalid-feedback">
                    <div *ngIf="eri.state.errors.required">
                      Enter state is required
                    </div>
                  </div>
                </div>

                <div class="form-group col-3">
                  <label>District</label>

                  <input type="text" formControlName="district" class="form-control" [(ngModel)]="district_single"
                    [attr.disabled]="true" />

                  <div *ngIf="submitted && eri.district.errors" class="invalid-feedback">
                    <div *ngIf="eri.district.errors.required">
                      Enter District is required
                    </div>
                  </div>
                </div>

                <div class="form-group col-3">
                  <label>ITI Code</label>
                  <input type="text" formControlName="iticode" class="form-control" [(ngModel)]="iticode_single"
                    [attr.disabled]="true" />

                  <div *ngIf="submitted && eri.iticode.errors" class="invalid-feedback">
                    <div *ngIf="eri.iticode.errors.required">
                      Enter ITI code is required
                    </div>
                  </div>
                </div>

                <div class="form-group col-3">
                  <label>Trade</label>

                  <select formControlName="trade" class="form-control" (change)="tradeChange($event)" [ngClass]="{
                      'is-invalid': submitted && eri.trade.errors
                    }">
                    <option [selected]="true" value="undefined" disabled="true">
                      Select Trade
                    </option>
                    <option *ngFor="let trad of trade_single" [value]="trad.trade">
                      {{ trad.trade }}
                    </option>
                  </select>
                  <div *ngIf="submitted && eri.trade.errors" class="invalid-feedback">
                    <div *ngIf="eri.trade.errors.required">
                      Select Trade is required
                    </div>
                  </div>
                </div>

                <div class="form-group col-3">
                  <label> Register Number</label>
                  <select formControlName="regno" class="form-control" (change)="rollnochange($event)" [ngClass]="{
                      'is-invalid': submitted && eri.regno.errors
                    }">
                    <option [selected]="true" value="undefined" disabled="true">
                      Select Rollno
                    </option>
                    <option *ngFor="let trad of eriregno_single" [value]="trad.regno">
                      {{ trad.regno }}
                    </option>
                  </select>
                  <div *ngIf="submitted && eri.regno.errors" class="invalid-feedback">
                    <div *ngIf="eri.regno.errors.required">
                      Enter Your Register Numbber
                    </div>
                  </div>
                </div>

                <div class="form-group col-3">
                  <label>Student Name</label>

                  <input type="text" formControlName="username" class="form-control" [(ngModel)]="eri_username"
                    [attr.disabled]="true" [ngClass]="{
                      'is-invalid': submitted && eri.username.errors
                    }" />

                  <div *ngIf="submitted && eri.username.errors" class="invalid-feedback">
                    <div *ngIf="eri.username.errors.required">
                      Enter Your User Name
                    </div>
                  </div>
                </div>

                <div class="form-group col-3">
                  <label>Exam Date</label>

                  <input type="text" formControlName="date" class="form-control" [(ngModel)]="eri_examdate"
                    [attr.disabled]="true" [ngClass]="{
                      'is-invalid': submitted && eri.date.errors
                    }" />

                  <div *ngIf="submitted && eri.date.errors" class="invalid-feedback">
                    <div *ngIf="eri.date.errors.required">Enter Your Exam Date</div>
                  </div>
                </div>

                <div class="form-group col-3">
                  <label>Shift</label>

                  <input type="text" formControlName="shift" class="form-control" [(ngModel)]="eri_shift"
                    [attr.disabled]="true" [ngClass]="{
                      'is-invalid': submitted && eri.shift.errors
                    }" />

                  <div *ngIf="submitted && eri.shift.errors" class="invalid-feedback">
                    <div *ngIf="eri.shift.errors.required">
                      Enter Your Shift
                    </div>
                  </div>
                </div>

                <div class="form-group col-9">
                  <label>Attendance</label>

                  <input type="text" formControlName="attendance" class="form-control" [(ngModel)]="eri_attendance"
                    [attr.disabled]="true" [ngClass]="{
                      'is-invalid': submitted && eri.attendance.errors
                    }" />

                  <div *ngIf="submitted && eri.attendance.errors" class="invalid-feedback">
                    <div *ngIf="eri.attendance.errors.required">
                      Enter Your Attendance
                    </div>
                  </div>
                </div>

                <div class="form-group col-3">
                  <label>Exam Status</label>

                  <input type="text" formControlName="status" class="form-control" [(ngModel)]="eri_examstatus"
                    [attr.disabled]="true" [ngClass]="{
                      'is-invalid': submitted && eri.status.errors
                    }" />

                  <div *ngIf="submitted && eri.status.errors" class="invalid-feedback">
                    <div *ngIf="eri.status.errors.required">
                      Enter Your Status
                    </div>
                  </div>
                </div>

                <div class="form-group col-12">
                  <label>Center</label>

                  <input type="text" formControlName="center" class="form-control" [(ngModel)]="eri_cenername"
                    [attr.disabled]="true" [ngClass]="{
                      'is-invalid': submitted && eri.center.errors
                    }" />

                  <div *ngIf="submitted && eri.center.errors" class="invalid-feedback">
                    <div *ngIf="eri.center.errors.required">
                      Enter Your Center
                    </div>
                  </div>
                </div>



                <div class="form-group col-4" *ngIf="ntefmain_bool">
                  <label>Nature of Technical Issue Faced</label>

                  <select class="form-control" (change)="ntefonChange($event)" formControlName="ntef" [ngClass]="{
                    'is-invalid': submitted && eri.ntef.errors
                  }">
                    <option [selected]="true" value="undefined" disabled="true">
                      Please Select
                    </option>
                    <option *ngFor="let ntef of NTEF" [value]="ntef.name">
                      {{ ntef.name }}
                    </option>
                  </select>

                  <div *ngIf="submitted && eri.ntef.errors" class="invalid-feedback">
                    <div *ngIf="eri.ntef.errors.required">
                      Select Your Issue
                    </div>
                  </div>
                </div>

                <div class="form-group col-4" *ngIf="ntefsub_bool">
                  <label>Issue Detail</label>

                  <select id="sel1" class="form-control" formControlName="issuedetail" [ngClass]="{
                    'is-invalid': submitted && eri.issuedetail.errors
                  }">
                    <option [selected]="true" value="undefined" disabled="true">
                      Please Select
                    </option>
                    <option *ngFor="let ntefsubs of ntefSub" [value]="ntefsubs">
                      {{ ntefsubs }}
                    </option>
                  </select>

                  <div *ngIf="submitted && eri.issuedetail.errors" class="invalid-feedback">
                    <div *ngIf="eri.issuedetail.errors.required">
                      Select Your Issue detail
                    </div>
                  </div>
                </div>

                <div class="form-group col-12" *ngIf="ntefdesc_bool">
                  <label>Description of the other issue</label>

                  <input type="text" formControlName="description" class="form-control" formControlName="description"
                    [ngClass]="{
                      'is-invalid': submitted && eri.description.errors
                    }" />

                  <div *ngIf="submitted && eri.description.errors" class="invalid-feedback">
                    <div *ngIf="eri.description.errors.required">
                      Select Your Issue detail description
                    </div>
                  </div>
                </div>

                <div class="form-group col-12">
                  <div class="text-center">
                    <button class="btn btn-primary mr-1">Submit</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <!--Form3 IF close-->
      </div>

      <div *ngIf="bool_eri_status">
        <div class="card m-3">
          <h5 class="card-header" style="font-size: 21px">
            Exam Related Issue Status
          </h5>
          <div class="card-body">
            <table>
              <tr>
                <th>TicketId</th>
                <th>Name</th>
                <th>Reg No</th>
                <th>ITI Code</th>
                <th>Nature of Technical Issue Faced</th>
                <th>Issue Detail</th>
                <th>Stattus</th>

              </tr>
              <tr *ngFor="let item of eri_status_admin let i=index">
                <td>{{item.refno}}</td>
                <td>{{item.username}}</td>
                <td>{{item.regno}}</td>
                <td>{{item.iticode}}</td>
                <td>{{item.ntef}}</td>
                <td>{{item.issuedetail}}</td>
                <td [class]="item.admin_status">{{item.admin_status}}</td>
              </tr>
            </table>
            <div style="padding: 10px" (click)="back_fn()"> <i class="fa fa-arrow-left" aria-hidden="true"></i>
              Back</div>
          </div>
        </div>
      </div>

      <div class="eriformr_res_cls" *ngIf="bool_eri_result">
        <p>Your Complaint has been Sucessfully Registered. </p>
        <p>Your ERI Ticket ID is <b> {{eri_genrateid}} </b> </p>
        <p>An Confirmation Email has been sent to your Registered Email Id <b>{{eri_email}}</b> </p>
        <p>The Status of your Complaint can be Tracked at <button class="track_btn_cls" (click)="grs_front_fn()">Track
            Your complaint </button> </p>
        <p>To Raise Exam Related Issue Click Here <button class="track_btn_cls" (click)="eri_again_fn()"> Exam Related
            Issue </button> </p>
      </div>

      <div class="eriformr_res_cls" *ngIf="bool_pri_result">
        <p>Your Complaint has been Sucessfully Registered. </p>
        <p>Your PRI Ticket ID is <b> {{pri_genrateid}} </b> </p>
        <p>An Confirmation Email has been sent to your Registered Email Id <b>{{eri_email}}</b> </p>
        <p>The Status of your Complaint can be Tracked at <button class="track_btn_cls" (click)="pri_front_fn()">Track
            Your complaint </button> </p>
        <p>To Raise Exam Related Issue Click Here <button class="track_btn_cls" (click)="pri_again_fn()"> Exam Related
            Issue </button> </p>
      </div>
      <!--FORM3 End-->

      <!--Track Comp start-->

      <!--Trac Comp End-->
    </div>
  </div>

  <div *ngIf="bool_trackComp">
    <div class="card m-3">
      <h5 class="card-header" style="font-size: 21px; background-color: red;" [ngStyle]="styleObject">
        Your Complaint Status {{this.pdu_admin_status}}
      </h5>
      <div class="card-body">
        <div class="row" style="text-align: left;">
          <div *ngIf="status_list_bool_pdu" class="col-md-12 status_tag">

            <table class="status_table">
              <tr>
                <th>Ticket Id</th>
                <td>{{this.pdu_ticketId}} </td>
              </tr>
              <tr>
                <th>Register Number</th>
                <td>{{this.pdu_singlerollno}} </td>
              </tr>
              <tr>
                <th>Order Id</th>
                <td>{{this.pdu_orderid}} </td>
              </tr>
              <tr>
                <th>Name</th>
                <td>{{this.pdu_name}} </td>
              </tr>
              <tr>
                <th>Email</th>
                <td>{{this.pdu_email}} </td>
              </tr>
              <tr>
                <th>Mobile Number</th>
                <td>{{this.pdu_mobileno}} </td>
              </tr>
              <tr>
                <th>ITI Code</th>
                <td>{{this.pdu_iticode}} </td>
              </tr>
              <tr>
                <th>Trade</th>
                <td>{{this.pdu_trade}} </td>
              </tr>
              <tr>
                <th>CC Ref Number</th>
                <td>{{this.pdu_ccrefno}} </td>
              </tr>
              <tr>
                <th>Date</th>
                <td>{{this.pdu_date}} </td>
              </tr>
              <tr>
                <th>State</th>
                <td>{{this.pdu_state}} </td>
              </tr>
              <tr>
                <th>District</th>
                <td>{{this.pdu_district}} </td>
              </tr>
              <tr>
                <th>Number Of Student</th>
                <td>{{this.pdu_numberofstud}} </td>
              </tr>
              <tr>
                <th>Description</th>
                <td>{{this.pdu_descreption}} </td>
              </tr>
              <tr>
                <th>Amount</th>
                <td>{{this.pdu_amount}} </td>
              </tr>
              <tr>
                <th>Admin Status</th>
                <td>{{this.pdu_admin_status}} </td>
              </tr>
              <tr>
                <th>Admin Status Description</th>
                <td>{{this.pdu_admin_status_desc}} </td>
              </tr>
            </table>

          </div>

          <hr>

          <div *ngIf="status_list_bool_eri" class="col-md-12 status_tag">

            <table class="status_table">
              <tr>
                <th>Ticket Id</th>
                <td>{{this.erform_ticketId}} </td>
              </tr>
              <tr>
                <th>Register Number</th>
                <td>{{this.erform_regno}} </td>
              </tr>
              <tr>
                <th>Status</th>
                <td>{{this.erform_status}} </td>
              </tr>
              <tr>
                <th>Name</th>
                <td>{{this.erform_name}} </td>
              </tr>
              <tr>
                <th>Email</th>
                <td>{{this.erform_email}} </td>
              </tr>
              <tr>
                <th>Center</th>
                <td>{{this.erform_center}} </td>
              </tr>
              <tr>
                <th>ITI Code</th>
                <td>{{this.erform_iticode}} </td>
              </tr>
              <tr>
                <th>Trade</th>
                <td>{{this.erform_trade}} </td>
              </tr>
              <tr>
                <th>Shift</th>
                <td>{{this.erform_shift}} </td>
              </tr>
              <tr>
                <th>Date</th>
                <td>{{this.erform_date}} </td>
              </tr>
              <tr>
                <th>State</th>
                <td>{{this.erform_state}} </td>
              </tr>
              <tr>
                <th>District</th>
                <td>{{this.erform_district}} </td>
              </tr>
              <tr>
                <th>Attendance</th>
                <td>{{this.erform_attendance}} </td>
              </tr>
              <tr>
                <th>Issue Detail</th>
                <td>{{this.erform_issuedetail}} </td>
              </tr>
              <tr>
                <th>NTEF</th>
                <td>{{this.erform_ntef}} </td>
              </tr>
              <tr>
                <th>Description</th>
                <td>{{this.erform_description}} </td>
              </tr>
              <tr>
                <th>Admin Status</th>
                <td>{{this.erform_admin_status}} </td>
              </tr>
              <tr>
                <th>Admin Status Description </th>
                <td>{{this.erform_admin_status_desc}} </td>
              </tr>
            </table>



          </div>
        </div>


      </div>
    </div>
  </div>

  <style>
    .banner_header {
      background: #2955a9;
      padding: 10px 0px;
      text-align: left;
      color: #fff;
      margin: 0px;
    }

    .banner_header h2 {
      font-size: 21px;
    }

    .accordion {
      background-color: #eee;
      color: #444;
      cursor: pointer;
      padding: 18px;
      width: 100%;
      border: none;
      text-align: left;
      outline: none;
      font-size: 15px;
      transition: 0.4s;
      position: relative;
    }

    .active,
    .accordion:hover {
      background-color: #ccc;
    }

    .panel {
      padding: 0 18px;
      display: none;
      background-color: white;
      overflow: hidden;
    }

    .panel p {
      padding: 10px 0px 0px;
    }

    .panel.hide {
      display: none;
    }

    .panel.show {
      display: block;
      text-align: left;
    }

    .arrow_cls {
      position: absolute;
      right: 15px;
      font-size: 21px;
      font-size: 21px;
    }

    .arrow_cls.hide {
      display: none;
    }

    .download_section {
      padding: 40px 0px;
      text-align: center;
    }

    .pad_size_cls {
      padding: 30px 0px;
    }

    .pad_btm_size {
      padding-bottom: 320px;
    }

    .date_cus {
      display: block !important;
    }

    ::ng-deep .dp-picker-input {
      display: block !important;
      width: 100% !important;
      height: calc(1.5em + 0.75rem + 2px) !important;
      padding: 0.375rem 0.75rem;
      font-size: 1rem !important;
      font-weight: 400;
      line-height: 1.5;
      color: #495057;
      background-color: #fff;
      background-clip: padding-box;
      border: 1px solid #ced4da;
      border-radius: 0.25rem;
      transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }

    .instruc_left,
    .instruc_right {
      background-color: #eee;
      border-radius: 20px;
      padding: 30px 0px;
      text-align: left;
    }

    .instruc_left {
      border-right: 10px solid #fff;
    }

    .instruc_right {
      border-left: 10px solid #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0px 15px;

    }

    .instrc_btn {
      margin-bottom: 10px;
      border-radius: 10px;
      background-color: #2955a9;
      color: #fff;
    }

    .instrc_btn:hover {
      background-color: #000;
      color: #fff;
    }

    .username_cls {
      text-align: right;
      padding: 10px;
      font-size: 18px;
    }

    .username_cls span {
      margin: 5px;

    }

    .username_cls span:last-child {
      cursor: pointer;
    }

    .eriformr_res_cls {
      background: #2955a9;
      padding: 30px 0px;
      color: #fff;
      border-radius: 10px;
      font-size: 19px;
    }

    .track_btn_cls {
      background: #fff;
      border: 0px;
      padding: 2px 10px 2px;
      border-radius: 5px;
      margin-left: 5px;
      box-shadow: 0px 1px 5px #fff;
      font-size: 17px;
    }

    .track_btn_cls:hover {
      background: #000;
      box-shadow: 0px 1px 5px #000;
      color: #fff;
    }
  </style>
</div>
